<template>
  <vs-row>
    <!-- 그래프 1 -->
    <vs-col class="w-full pb-4">
      <monthly-chart-card :title="graph1.title" :year="graph1.year" :data1="graph1.data1" :data2="graph1.data2" @change="yearChangeForGraph1" />
    </vs-col>

    <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4 mb-4">
      <!-- 그래프 2-->
      <vs-col>
        <monthly-comparison-card :title="graph2.title" :year="graph2.year" :month="graph2.month" :unit="graph2.unit" :heads="graph2.heads" :list="graph2.list" :getCol="getColForGraph2" @change="dateChangeForGraph2">
          <template slot="tools" :set="(lv = getLevel)">
            <vs-button v-if="lv === 1 || lv === 2" class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph2('부서')">관련 부서</vs-button>
            <vs-button v-if="lv === 1" class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph2('사업장')">사업장/시설물</vs-button>
            <vs-button class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph2('구분')">구분</vs-button>
            <vs-button class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph2('직종')">직종</vs-button>
          </template>
        </monthly-comparison-card>
      </vs-col>

      <!-- 그래프 3 -->
      <vs-col>
        <daily-comparison-card dateType="yyyy-mm" :title="graph3.title" :unit="graph3.unit" :year="graph3.year" :month="graph3.month" :list="graph3.list" @change="dateChangeForGraph3">
          <template slot="tools" :set="(lv = getLevel)">
            <vs-button v-if="lv === 1 || lv === 2" class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph3('부서')">관련 부서</vs-button>
            <vs-button v-if="lv === 1" class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph3('사업장')">사업장/시설물</vs-button>
            <vs-button class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph3('구분')">구분</vs-button>
            <vs-button class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataTypeChangeForGraph3('직종')">직종</vs-button>
          </template>
        </daily-comparison-card>
      </vs-col>
    </div>

    <!-- 그래프 4-->
    <vs-col class="w-full pb-4">
      <monthly-comparison-card :title="graph4.title" :year="graph4.year" :month="graph4.month" :unit="graph4.unit" :heads="graph4.heads" :list="graph4.list" :getCol="getColForGraph4" @change="dateChangeForGraph4">
        <template slot="tools">
          <div class="w-full">
            <vs-select class="w-full lg:w-48" autocomplete v-model="graph4.dataType1" @change="dataType1ChangeForGraph4">
              <vs-select-item value="부서" text="부서별" />
              <vs-select-item value="사업장" text="사업장별" />
            </vs-select>
          </div>
          <vs-button class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataType2ChangeForGraph4('구분')">구분</vs-button>
          <vs-button class="py-3 px-0 lg:px-8" type="border" color="secondary" @click="dataType2ChangeForGraph4('구분_직종')">구분+직종</vs-button>
        </template>
      </monthly-comparison-card>
    </vs-col>
  </vs-row>
</template>

<script>
import MonthlyChartCard from "@/views/graph-detail/components/MonthlyChartCard";
import GraphUtil from "@/util/GraphUtil";
import MonthlyChartCard2 from "@/views/graph-detail/components/MonthlyChartCard2";
import MonthlyComparisonCard from "@/views/graph-detail/components/MonthlyComparisonCard";
import MonthlyComparisonUtil from "@/util/MonthlyComparisonUtil";
import DailyComparisonUtil from "@/util/DailyComparisonUtil";
import CircleGraphUtil from "@/util/CircleGraphUtil";
import DailyComparisonCard from "@/views/graph-detail/components/DailyComparisonCard";
import tabItems from "@/views/boards/tab/tab-items";
export default {
  name: "GraphDetail02",
  components: {
    DailyComparisonCard,
    MonthlyComparisonCard,
    MonthlyChartCard2,
    MonthlyChartCard,
  },
  props: {
    comGroupList: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    graphId() {
      return Number(this.$route.params.graphId);
    },
    isApproval() {
      return tabItems[553].isApproval;
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const proj of projects) {
          if (proj.id == this.projectId && proj.company.length > 0) {
            const path = proj.company[0].pivot.company_path;
            const lv = path.split("/").length - 1;
            return lv;
          }
        }
      }
    },
  },
  data() {
    return {
      boardId: 553,
      summaryKey: ["종사자_직종", "count"],
      graph1: {
        title: "종사자 현황",
        year: new Date().getFullYear(),
        data1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도
        data2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도의 이전 년도
      },
      graph2: {
        title: "월별 종사자 인원 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        heads: [{ name: "No." }, { name: "부서(업체명)" }, { name: "명" }, { name: "전월대비 증감" }],
        list: [],
        summaryKey1: "",
        dataType: "부서",
      },
      graph3: {
        title: "월별 종사자 인원 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        beginDate: new Date().format("yyyy-MM-dd"),
        endDate: new Date().format("yyyy-MM-dd"),
        list: [],
        dataType: "부서",
      },
      graph4: {
        title: "상세 내부종사자 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        heads: [{ name: "No." }, { name: "부서명" }, { name: "구분" }, { name: "명" }, { name: "전월대비 증감" }],
        list: [],
        summaryKey1: "",
        dataType1: "부서",
        dataType2: "구분",
      },
    };
  },
  async mounted() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");

    await this.loadGraph1();
    await this.loadGraph2();
    await this.loadGraph3();
    await this.loadGraph4();
  },

  methods: {
    convertListData(list) {
      // 데이터 변형하기,
      // 매달 마지막에 작성 글을 기준으로 변경하기,
      const temp = {};
      for (const data of list) {
        const date = new Date(data.created_at).format("yyyy-MM-01");
        if (data.post_content) {
          temp[date] = JSON.parse(data.post_content);
        }
      }
      return temp;
    },

    getData월별총합막대그래프(value, summaryKey) {
      const yearKeys = Object.keys(value);
      const data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      for (const year of yearKeys) {
        if (year && year.indexOf("-") >= 0) {
          const temp = year.split("-");
          const m = Number(`${temp[1]}`);

          const colData = value[year].summary[summaryKey];
          for (const col of colData) {
            const key = Object.keys(col);
            data[m - 1] += Number(`${col[key[0]]}`);
          }
        }
      }
      return data;
    },

    // 그래프 1
    async loadGraph1() {
      const yyyy = this.graph1.year;
      const projectId = this.$route.params.proj_id;
      const boardId = 553; //state_government
      const page = 1;
      const perPage = 10000;
      let newList = [];
      let prevList = [];

      // newList
      if (this.isApproval) {
      } else {
        const dateBegin = `${yyyy}-01-01`;
        const dateEnd = `${yyyy}-12-31`;
        await this.$store.dispatch("board/LOAD_POST_LIST", {
          projectId,
          boardId,
          page,
          perPage,
          dateTarget: "created_at",
          dateBegin,
          dateEnd,
        });
        newList = this.convertListData(this.$store.state.board.postListInfo.data);
      }

      // prevList
      if (this.isApproval) {
      } else {
        const dateBegin = `${yyyy - 1}-01-01`;
        const dateEnd = `${yyyy - 1}-12-31`;
        await this.$store.dispatch("board/LOAD_POST_LIST", {
          projectId,
          boardId,
          page,
          perPage,
          dateTarget: "created_at",
          dateBegin,
          dateEnd,
        });
        prevList = this.convertListData(this.$store.state.board.postListInfo.data);
      }

      this.graph1.data1 = this.getData월별총합막대그래프(newList, "종사자현황_구분");
      this.graph1.data2 = this.getData월별총합막대그래프(prevList, "종사자현황_구분");
    },
    yearChangeForGraph1(year) {
      this.graph1.year = year;
      this.loadGraph1();
    },

    // 그래프 2
    async loadGraph2() {
      const yyyy = this.graph2.year;
      const mm = this.graph2.month > 9 ? this.graph2.month : `0${this.graph2.month}`;
      const projectId = this.$route.params.proj_id;
      const boardId = 553; //state_government
      const page = 1;
      const perPage = 10000;
      let newList = [];
      let prevList = [];

      // newList
      if (this.isApproval) {
      } else {
        const dateBegin = `${yyyy}-${mm}-01`;
        const dateEnd = `${yyyy}-${mm}-31`;
        await this.$store.dispatch("board/LOAD_POST_LIST", {
          projectId,
          boardId,
          page,
          perPage,
          dateTarget: "created_at",
          dateBegin,
          dateEnd,
        });
        newList = this.convertListData(this.$store.state.board.postListInfo.data);
      }

      // prevList
      if (this.isApproval) {
      } else {
        const dateBegin = mm === 1 ? `${yyyy}-${mm - 1}-01` : `${yyyy - 1}-12-01`;
        const dateEnd = mm === 1 ? `${yyyy}-${mm - 1}-31` : `${yyyy - 1}-12-31`;
        await this.$store.dispatch("board/LOAD_POST_LIST", {
          projectId,
          boardId,
          page,
          perPage,
          dateTarget: "created_at",
          dateBegin,
          dateEnd,
        });
        prevList = this.convertListData(this.$store.state.board.postListInfo.data);
      }

      this.graph2.list = this.moduleWithData2(this.graph2.dataType, newList, prevList);

      // {
      //   name: comName,
      //     value: value[comName].value,
      //   gap: value[comName].gap
      // }

      // this.graph2.labels = value.labels
      // this.graph2.data1 = value.data1
      // this.graph2.data2 = value.data2
    },
    getColForGraph2(index, value) {
      if (index === 0) return value.no;
      if (index === 1) return value.name;
      if (index === 2) return value.value;
      if (index === 3) {
        let updown = "default";
        if (value.gap > 0) updown = "up";
        else if (value.gap < 0) updown = "down";
        return { type: updown, value: value.gap };
      }
      return "";
    },
    moduleWithData2(dataType, newValue, oldValue) {
      let key = `종사자현황_${dataType}`;
      const newKey = Object.keys(newValue);
      const oldKey = Object.keys(oldValue);
      const newTemp = newValue[newKey[0]] ? newValue[newKey[0]].summary[key] : [];
      const oldTemp = oldValue[oldKey[0]] ? oldValue[oldKey[0]].summary[key] : [];

      const newDataList = newTemp && newTemp.length > 0 ? newTemp : [];
      const oldDataList = oldTemp && oldTemp.length > 0 ? oldTemp : [];

      const moduleTemp = {};
      // newData
      for (const newData of newDataList) {
        for (const comName of Object.keys(newData)) {
          moduleTemp[comName] = {
            value: Number(`${newData[comName]}`),
            gap: Number(`${newData[comName]}`),
          };
        }
      }

      // oldData
      for (const oldData of oldDataList) {
        for (const comName of Object.keys(oldData)) {
          if (moduleTemp[comName]) {
            moduleTemp[comName].gap -= Number(`${oldData[comName]}`);
          } else {
            moduleTemp[comName] = {
              value: oldData[comName],
              gap: -1 * Number(`${oldData[comName]}`),
            };
          }
        }
      }

      return MonthlyComparisonUtil.moduleWithData(moduleTemp);
    },
    yearChangeForGraph2(year) {
      this.graph2.year = year;
      this.loadGraph2();
    },
    dataTypeChangeForGraph2(dataType) {
      this.graph2.dataType = dataType;

      if (dataType === "부서") this.graph2.heads = [{ name: "No." }, { name: "부서(업체)명" }, { name: "명" }, { name: "전월대비 증감" }];
      else if (dataType === "사업장") this.graph2.heads = [{ name: "No." }, { name: "사업장명" }, { name: "명" }, { name: "전월대비 증감" }];
      else if (dataType === "구분") this.graph2.heads = [{ name: "No." }, { name: "구분" }, { name: "명" }, { name: "전월대비 증감" }];
      else if (dataType === "직종") this.graph2.heads = [{ name: "No." }, { name: "직종" }, { name: "명" }, { name: "전월대비 증감" }];

      this.loadGraph2();
    },
    dateChangeForGraph2(year, month) {
      this.graph2.year = year;
      this.graph2.month = month;
      this.loadGraph2();
    },

    // 그래프 3
    async loadGraph3() {
      const yyyy = this.graph3.year;
      const mm = this.graph3.month > 9 ? this.graph3.month : `0${this.graph3.month}`;
      const projectId = this.$route.params.proj_id;
      const boardId = 553; //state_government
      const page = 1;
      const perPage = 10000;
      let newList = [];
      let prevList = [];

      // newList
      if (this.isApproval) {
      } else {
        const dateBegin = `${yyyy}-${mm}-01`;
        const dateEnd = `${yyyy}-${mm}-31`;
        await this.$store.dispatch("board/LOAD_POST_LIST", {
          projectId,
          boardId,
          page,
          perPage,
          dateTarget: "created_at",
          dateBegin,
          dateEnd,
        });
        newList = this.convertListData(this.$store.state.board.postListInfo.data);
      }

      this.graph3.list = this.moduleWithData3(this.graph3.dataType, newList);
    },
    dateRangeChangeForGraph3(beginDate, endDate) {
      this.graph3.beginDate = beginDate;
      this.graph3.endDate = endDate;
      this.loadGraph3();
    },
    moduleWithData3(dataType, newValue) {
      let key = `종사자현황_${dataType}`;
      const newKey = Object.keys(newValue);
      const newTemp = newValue[newKey[0]] ? newValue[newKey[0]].summary[key] : [];

      const newDataList = newTemp && newTemp.length > 0 ? newTemp : [];

      const moduleTemp = {};
      // newData
      for (const newData of newDataList) {
        for (const comName of Object.keys(newData)) {
          moduleTemp[comName] = Number(`${newData[comName]}`);
        }
      }

      return GraphUtil.moduleWithData(moduleTemp);
    },
    dateChangeForGraph3(year, month) {
      this.graph3.year = year;
      this.graph3.month = month;
      this.loadGraph3();
    },
    dataTypeChangeForGraph3(dataType) {
      this.graph3.dataType = dataType;
      this.loadGraph3();
    },

    // 그래프 4
    async loadGraph4() {
      const yyyy = this.graph4.year;
      const mm = this.graph4.month > 9 ? this.graph4.month : `0${this.graph4.month}`;
      const projectId = this.$route.params.proj_id;
      const boardId = 553; //state_government
      const page = 1;
      const perPage = 10000;
      let newList = [];
      let prevList = [];

      // newList
      if (this.isApproval) {
      } else {
        const dateBegin = `${yyyy}-${mm}-01`;
        const dateEnd = `${yyyy}-${mm}-31`;
        await this.$store.dispatch("board/LOAD_POST_LIST", {
          projectId,
          boardId,
          page,
          perPage,
          dateTarget: "created_at",
          dateBegin,
          dateEnd,
        });
        newList = this.convertListData(this.$store.state.board.postListInfo.data);
      }

      // prevList
      if (this.isApproval) {
      } else {
        const dateBegin = mm === 1 ? `${yyyy}-${mm - 1}-01` : `${yyyy - 1}-12-01`;
        const dateEnd = mm === 1 ? `${yyyy}-${mm - 1}-31` : `${yyyy - 1}-12-31`;
        await this.$store.dispatch("board/LOAD_POST_LIST", {
          projectId,
          boardId,
          page,
          perPage,
          dateTarget: "created_at",
          dateBegin,
          dateEnd,
        });
        prevList = this.convertListData(this.$store.state.board.postListInfo.data);
      }

      this.graph4.list = this.moduleWithData4(this.graph4.dataType1, this.graph4.dataType2, newList, prevList);

      // {
      //   name: comName,
      //     value: value[comName].value,
      //   gap: value[comName].gap
      // }

      // this.graph2.labels = value.labels
      // this.graph2.data1 = value.data1
      // this.graph2.data2 = value.data2
    },
    getColForGraph4(index, value) {
      if (this.graph4.dataType2 === "구분_직종") {
        if (index === 0) return value.no;
        if (index === 1) return value["부서명"];
        if (index === 2) return value["구분"];
        if (index === 3) return value["직종"];
        if (index === 4) return value.value;
        if (index === 5) {
          let updown = "default";
          if (value.gap > 0) updown = "up";
          else if (value.gap < 0) updown = "down";
          return { type: updown, value: value.gap };
        }
      } else {
        if (index === 0) return value.no;
        if (index === 1) return value["부서명"];
        if (index === 2) return value["구분"];
        if (index === 3) return value.value;
        if (index === 4) {
          let updown = "default";
          if (value.gap > 0) updown = "up";
          else if (value.gap < 0) updown = "down";
          return { type: updown, value: value.gap };
        }
      }
      return "";
    },
    moduleWithData4(dataType1, dataType2, newValue, oldValue) {
      let key = `종사자현황_${dataType1}_${dataType2}`;
      const newKey = Object.keys(newValue);
      const oldKey = Object.keys(oldValue);
      const newTemp = newValue[newKey[0]] ? newValue[newKey[0]].summary[key] : [];
      const oldTemp = oldValue[oldKey[0]] ? oldValue[oldKey[0]].summary[key] : [];

      const newDataList = newTemp && newTemp.length > 0 ? newTemp : [];
      const oldDataList = oldTemp && oldTemp.length > 0 ? oldTemp : [];

      const moduleTemp = {};
      // newData
      for (const newData of newDataList) {
        for (const key of Object.keys(newData)) {
          const keys = key.split("_");
          moduleTemp[key] = {
            부서명: keys[0], //부서명/사업장명
            구분: keys[1], //부서명
            직종: keys[2], //부서명
            value: Number(`${newData[key]}`),
            gap: Number(`${newData[key]}`),
          };
        }
      }

      // oldData
      for (const oldData of oldDataList) {
        for (const key of Object.keys(oldData)) {
          const keys = key.split("_");
          if (moduleTemp[key]) {
            moduleTemp[key].gap -= Number(`${oldData[key]}`);
          } else {
            moduleTemp[key] = {
              부서명: keys[0], //부서명/사업장명
              구분: keys[1], //부서명
              직종: keys[2], //부서명
              value: oldData[key],
              gap: -1 * Number(`${oldData[key]}`),
            };
          }
        }
      }

      const value = moduleTemp;
      const module = [];
      for (const comName of Object.keys(value)) {
        module.push({
          부서명: value[comName].부서명,
          구분: value[comName].구분,
          직종: value[comName].직종,
          value: value[comName].value,
          gap: value[comName].gap,
        });
      }

      // graph 에서 사용하는 형식으로 데이터 변경후 반환해야 함
      // list = [{ no: 1, name: '사업장', value: 1000000, gap: -100 }]
      for (let i = 0; i < module.length; i++) {
        module[i].no = i + 1;
      }
      return module;
      return this.moduleWithData4(moduleTemp);
    },
    dateChangeForGraph4(year, month) {
      this.graph4.year = year;
      this.graph4.month = month;
      this.loadGraph4();
    },
    dataType1ChangeForGraph4() {
      if (this.graph4.dataType2 === "구분") {
        this.graph4.heads = [{ name: "No." }, { name: this.graph4.dataType1 === "부서" ? "부서명" : "사업장명" }, { name: "구분" }, { name: "명" }, { name: "전월대비 증감" }];
      } else {
        this.graph4.heads = [{ name: "No." }, { name: this.graph4.dataType1 === "부서" ? "부서명" : "사업장명" }, { name: "구분" }, { name: "직종" }, { name: "명" }, { name: "전월대비 증감" }];
      }
      this.loadGraph4();
    },
    dataType2ChangeForGraph4(dataType) {
      this.graph4.dataType2 = dataType;

      this.dataType1ChangeForGraph4();
    },
  },
};
</script>

<style scoped></style>
